import { ExportTableAction } from '../../state';
import { RootState } from '../..';
import { useSelector } from 'react-redux';

export const useExportReportMetadata = (): ExportTableAction =>
  useSelector((state: RootState) => state.ExportReport);
